import axios from 'axios';
import { getEpisodes, loadingEpisodes } from './episodeContainer.actions';
//import { postExecute } from '../../../services/api/microfwk';

export const getEpisodesRequested = urlGetEpisode => async dispatch => {
  let res = [];
  try {
    dispatch(loadingEpisodes({ active: true })); // activa el loading

    if (urlGetEpisode) {
      res = await axios(urlGetEpisode); // optiene los episodios
    }

    if (res?.status === 200) {
      const episodesData = res?.data?.response?.recordings || [];
      const episoddesStatusValidate = episodesData?.filter(episode => {
        if (
          episode?.status === 'ingested' ||
          episode?.status === 'recording' ||
          episode?.status === 'scheduled'
        ) {
          return episode;
        }
      });

      const payload = {
        episodes: episoddesStatusValidate || [],
      };
      const action = getEpisodes(payload);
      dispatch(action); // se agregan los eposidios al state episodeContainer
      dispatch(loadingEpisodes({ active: false }));
    }
  } catch (error) {
    dispatch(loadingEpisodes({ active: false }));
  }
};

export const deleteEpisodeRequested = options => async (dispatch, getState) => {
  let res = [];
  const state = getState();
  const { deleteURl, idPoster, deleteAnalytics } = options || {};

  try {
    const filterEpisode = () => {
      const newListEpisodes = state?.episodeContainer?.episodes?.filter(
        episode => episode?.record_id !== idPoster,
      );
      return newListEpisodes;
    };

    if (deleteURl) {
      res = await axios.post(deleteURl);
    }

    if (res?.status === 200) {
      const newListEpisodes = filterEpisode();
      const payload = {
        episodes: newListEpisodes || [],
      };
      dispatch(getEpisodes(payload));

      if (typeof deleteAnalytics === 'function') {
        deleteAnalytics();
      }
    }
  } catch (error) {
    console.error(error);
  }
};
